export function hourlyToMonthly(hourlyValue: number): number {
    return hourlyValue * hoursPerMonth;
}
//#region Un-mockable configuration
// (NB: Do not add anything here unless absolutely necessary!)

export const hoursPerMonth = 730;
